import React from 'react';
import PropTypes from 'prop-types';
import { Spinner } from 'reactstrap';
import './Loading.css'; // Import your custom CSS file

const Loading = ({ 
  message = 'Loading...', 
  showSpinner = true, 
  spinnerColor = 'primary', 
  className = '' 
}) => {
  return (
    <div className={`loading-overlay ${className}`} role="alert" aria-busy="true">
      <div className="loading-container">
        {showSpinner && <Spinner color={spinnerColor} />}
      </div>
    </div>
  );
};

Loading.propTypes = {
  message: PropTypes.string,
  showSpinner: PropTypes.bool,
  spinnerColor: PropTypes.string,
  className: PropTypes.string,
};

export default Loading;
